<template>
	<div class="bodyall Verticalcenter-line" >
		<div class="homepageHead between-line">
			<div class="Centerupdown" v-if="config.company=='hls'">
				<img  src="../../../assets/img/homepageIcon.png" style="width: 78px;height: 30px;"/>
				<div class="home-line"></div>
				<div class="home-text">和利时税务管理系统</div>
			</div>
			<div class="Centerupdown" style="font-size: 14px;color: #FFFFFF;">
				<div class="showyhm Centerupdown">{{userInfo.nickName}}</div>
				<div class="Centerupdown" style="margin-left: 16px;cursor: pointer;" @click="upmodify">
					<img src="../../../assets/img/uppassword.png" style="width: 20px;height: 20px;" />
					<span>修改密码</span>
				</div>
				<div class="Centerupdown" style="margin-left: 16px;margin-right: 9px;cursor: pointer;" @click="forout">
					<img src="../../../assets/img/backlogin.png" style="width: 20px;height: 20px;" />
					<span>退出登陆</span>
				</div>
			</div>
		</div>
		<el-dialog width="424px" title="修改密码" :visible.sync="modify" append-to-body
			:close-on-click-modal="false">
			<taxform class="inputborder" :Formlist="formlist" @getdata="getdata" :formdata="formdata" labelwidth="100px" ref="taxform">
			</taxform>
			<div class="end-flex" style="margin-top: 20px;">
				<div class="backstyle" @click="modify=false" style="margin-right: 24px;width: 60px;">
					返回
				</div>
				<div class="addstyle" @click="nextpassword" style="width: 60px;">
					确认
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="homediagtitle" :visible.sync="homediag" :close-on-click-modal="false"
			:close-on-press-escape="false" width="600px" v-dialogDrag>
			<div class="Verticalcenter diagall">
				<div class="diagall-1">没有登录该系统的权限，请联系管理员</div>
			</div>
		</el-dialog>
		<div class="homebody Verticalcenter-line">
			<img  src="../../../assets/img/homepage/toptext.svg" class="toptext"/>
			<div class="homebody-item Centerupdown" style="margin-top: 146px;">
				<div v-for="item in list" class="Verticalcenter itemimg" :style="!item.enable?'opacity: 0.5;':''" @click="foritem(item)">
					<img :src="item.img" />
					<div >{{item.name}}</div>
				</div>
			</div>
			<img src="../../../assets/img/homepage/bottomback.svg" class="bottomback"/>
		</div>
	</div>
</template>

<script>
	import config from '../../../../configHttp.js'
	import {updatePass,checkPasswordTime} from '../../../../../front/src/api/password.js'
	export default {
		name: "Homepage",
		data() {
			return {
				config:config,
				userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
				formdata: {
					dqPassword: '',
					xgPassword: '',
					qrPassword: ''
				},
				formlist: [
					{
						prop: 'dqPassword',
						label: '当前密码',
						type: 'input',
						width: '220px',
						ispassword: true,
						isnotnull: true,
					},
					{
						prop: 'xgPassword',
						label: '修改密码',
						type: 'input',
						width: '220px',
						ispassword: true,
						isnotnull: true,
						Customtips: '8位以上包含大小写字母、数字(不连续)、特殊字符',
						Customrules: /^(?!.*(?:(\d)\1|01|12|23|34|45|56|67|78|89|98|87|76|65|54|43|32|21|10))(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F])[\da-zA-Z\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]{8,}$/
					},
					{
						prop: 'qrPassword',
						label: '确认密码',
						width: '220px',
						type: 'input',
						ispassword: true,
						isnotnull: true,
					}
				],
				list: [{
					img: require('../../../assets/img/01.svg'),
					name: '销项系统',
					title: 'oinv', // 对应模块名称
					url: '', // 点击后跳转的地址
				}, {
					img: require('../../../assets/img/02.svg'),
					name: '进项系统',
					title: 'iinv',
					url: '',
				},
				{//纳税申报自有系统
					img: require('../../../assets/img/03.svg'),
					name: '纳税申报',
					title: 'nssb',
					enable:false,
					url: 'home',
				}, {
					img: require('../../../assets/img/04.svg'),
					name: '税务风控',
					title: 'nssb',
					enable:false,
					url: 'fxjk',
				}, {
					img: require('../../../assets/img/05.svg'),
					name: '税务知识库',
					title: 'nssb',
					enable:false,
					url: 'zcfg',
				}
				],
				modify:false,
				homediagtitle: "",
				homediag: false,
				homdataall: [],
				indeximg: '', //多余字段
				// 此段参数用来启动页面的分区模块登录功能

			}
		},
		created() {
			// 单点登录相关 页面创建后读取sessionStorage内的模块登录记录，读取到结果后对相应模块进行渲染，是否允许登录
			let meaurouter=localStorage.getItem('meaurouter')
			this.list.forEach(item=>{
				if(meaurouter.indexOf(item.url) != -1&&item.url!=''){
					item.enable=true
				}else{
					item.enable=false
				}
			})
			var moduleInfo = JSON.parse(localStorage.getItem("moduleInfo"))
			if(moduleInfo){
				moduleInfo.forEach(item => {
					this.list.forEach(gtem => {
						if (item.moduleName == gtem.title) {
							gtem.homeurl = item.homeurl
							gtem.enable = item.enable
							gtem.token = item.token
							gtem.key = item.key
						}
					})
				})
			}
		},
		mounted() {
			this.page()
		},
		methods: {
			page(){
				checkPasswordTime().then(res=>{
					if(res.data.code == 1){
						if(!!res.data.data&&res.data.data!='操作成功'){
							this.$message.error(res.data.data)
						}
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			getdata(e){
				let userId = JSON.parse(localStorage.getItem('userInfo'))
				let params = {
					userId:userId.id,
					currentPass:this.formdata.dqPassword,
					newPass:this.formdata.xgPassword,
					confPass:this.formdata.qrPassword,
				}
				updatePass(params).then(res=>{
					 if(res.data.code==1){
						this.modify = false
						this.$message.success('密码修改成功')
						this.forout()
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			nextpassword(){
				this.$refs.taxform.submitForm()
			},
			upmodify(){
				this.modify = true
				Object.keys(this.formdata).map(key=>{this.formdata[key] = ''})
			},
			forout(){
				 localStorage.clear();
				 this.$router.push('/login');
			},
			foritem(item) {
				if (item.enable) {
					if(item.title=='nssb'){
						if(item.url=='zcfg'){
							var meaus=JSON.parse(localStorage.getItem("meaus")) 
							let zcfgmeaus=[]
							meaus.forEach(item=>{
								if(item.resCode=='Taxknowledgebase'){
									zcfgmeaus.push(item)
								}
							})
							localStorage.setItem('hlsmeaus','')
							localStorage.setItem('zcfgmeaus',JSON.stringify(zcfgmeaus))
							localStorage.setItem('hmdglmeaus','')
						}
						if(item.url=='fxjk'){
							var meaus=JSON.parse(localStorage.getItem("meaus")) 
							let hmdglmeaus=[]
							meaus.forEach(item=>{
								if(item.resCode=='Riskmanagement'){
									item.children.forEach((gtem,index)=>{
										if(gtem.resCode=='fxjk'){
											let newobj=JSON.parse(JSON.stringify(gtem))
											item.children.splice(index,1)
											item.children.unshift(newobj)
										}
									})
									hmdglmeaus.push(item)
								}
							})
							localStorage.setItem('hlsmeaus','')
							localStorage.setItem('zcfgmeaus','')
							localStorage.setItem('hmdglmeaus',JSON.stringify(hmdglmeaus))
						}
						if(item.url=='home'){
							var meaus=JSON.parse(localStorage.getItem("meaus")) 
							meaus.forEach((item,index)=>{
								if(item.resCode=='Taxknowledgebase'){
									meaus.splice(index,1)
								}
							})
							meaus.forEach((item,index)=>{
								if(item.resCode=='Riskmanagement'){
									meaus.splice(index,1)
								}
							})
							localStorage.setItem("hlsmeaus", JSON.stringify(meaus))
							localStorage.setItem('zcfgmeaus','')
							localStorage.setItem('hmdglmeaus','')
						}
						 this.$router.push('/'+item.url)
					}else{
						location.href=item.homeurl
					}
				} else {
					this.homediagtitle = item.name
					this.indeximg = item.img
					this.homediag = true
				}

			},
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>
